<template>
  <div class="pvscan-container">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/banner3.png"
        alt=""
        class="pc-banner"
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/auto_inspection_banner_mobile.png"
        class="mobile-banner"
        alt=""
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          光伏一点通-无人值守巡检平台
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          自动巡检 智慧值守
        </div>
        <div
          class="use-button wow fadeInUp"
          @click="openCodeDialog"
          data-wow-delay="0.7s"
        >
          申请试用
        </div>
      </div>
    </div>

    <div class="block-wrap mobile-pad" style="background-color: #f5f7fa">
      <div class="block-title page-block-title">产品简介</div>
      <div class="block-desc page-block-desc">
        无人机+机库7x24小时在线，随时待命，收到定期或即时任务，自动飞行作业、上传数据及智能隐患分析，让电站巡视无忧。
      </div>
      <div class="content-wrap">
        <!-- <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/product_login2.png" class="platform-bg" alt=""> -->
        <div class="product-row">
          <div class="product-column">
            <div class="top-img fly-block"></div>
            <div class="bottom-text">
              <div class="product-title">自动机库</div>
              <div class="product-desc">
                <div>无人机+机库7x24小时在线，</div>
                <div>自动收纳、充放电。</div>
              </div>
            </div>
          </div>

          <div class="product-column">
            <div class="top-img analysis-block"></div>
            <div class="bottom-text">
              <div class="product-title">自动起飞作业</div>
              <div class="product-desc">
                <div>无人机按照规划的航线和巡检任</div>
                <div>务自动飞行并作业。</div>
              </div>
            </div>
          </div>

          <div class="product-column">
            <div class="top-img defect-block"></div>
            <div class="bottom-text">
              <div class="product-title">智能分析</div>
              <div class="product-desc">
                <div>平台对无人机巡检的照片进行分</div>
                <div>析处理，识别各种问题及隐患。</div>
              </div>
            </div>
          </div>

          <div class="product-column">
            <div class="top-img auto-defect-block"></div>
            <div class="bottom-text">
              <div class="product-title">精准消缺</div>
              <div class="product-desc">
                <div>使用去消缺APP，</div>
                <div>导航定位缺陷并进行消缺处理。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平台功能 -->
    <div class="block-wrap">
      <div class="block-title page-block-title">主要功能</div>
      <div class="block-content pc-platform">
        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img14.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">底图建模</div>
              <div class="desc">
                系统对巡检区域进行二维建模生成全景图，将该区域的光伏情况以更宏观的形式展示出来，并生成精细化图片。
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">航线规划</div>
              <div class="desc">
                在计划飞行区域内绘制想要飞行的区域，系统自动生成航线，无需导入航线文档，还可及时对航线参数进行修改。
              </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img15.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img16.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">任务制定</div>
              <div class="desc">
                可提前在平台上制定任务，包括临时任务和周期性任务。将任务与航线关联，无人机按照规定航线和时间自主飞行巡检。
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">自动飞行</div>
              <div class="desc">
                无人机按照规划的航线和任务，自动出库飞行巡检。航飞视频实况直播，遇突发状况，还可对无人机实现一键返航。
              </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img17.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img18.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">智能识别</div>
              <div class="desc">
                可见光+热红外双光检测，可识别点状热斑、竖条状热斑、横条状热斑、全红热斑、厚积尘、遮挡、鸟粪、破损等8大类型缺陷。
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">消缺复核</div>
              <div class="desc">
                运维主管可在系统的缺陷管理模块进行消缺审核，确保故障得到完全解决，以提高电站的安全性和稳定性，延长电站
                使用寿命。
              </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img19.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img20.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">输出报告</div>
              <div class="desc">
                项目基本情况、巡检执行的规范标准、巡检的流程、异常组件分布图、导致缺陷的原因分析及处理的建议等。
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="block-content mobile-platform">
        <mobileCarousel></mobileCarousel>
      </div>
    </div>
    <div class="mask" v-if="codeDialogFlag">
      <codeCard
        @closeDialog="closeDialog"
        :codeDialogFlag="codeDialogFlag"
      ></codeCard>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import mobileCarousel from "./components/soloar-sentry-carousel.vue";
import codeCard from "./components/inspection-code.vue";

export default {
  components: {
    mobileCarousel,
    codeCard,
  },
  data() {
    return {
      codeDialogFlag: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    closeDialog() {
      this.codeDialogFlag = false;
    },
    openCodeDialog() {
      this.codeDialogFlag = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
    .mask {
    width: 100%;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,0.7);
    display:flex;
    justify-content:center;
    z-index:15;
    align-items:center;
}
  .pvscan-container {
      width:100%;
      .mobile-platform {
        display:none;
    }
      .layout-banner {
          height:100vh;
          position:relative;
          @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
          img {
              height:100%;
              width: 100%;
              object-fit: cover;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
              transition: transform 0.3s ease-out;
              animation: zoomIn 3s ease-out forwards;

          }
          .text-block {
              position:absolute;
              top:50%;
              left:13%;
              transform: translateY(-50%);
              z-index: 2;
              color:#fff;
              .title {
                  font-size:3rem;
                  letter-spacing: 2px;
                  font-weight: bold;
                  margin-bottom:1.44rem;
              }
              .desc {
                  letter-spacing: 2px;
                  width:625px;
                  white-space: wrap;
                  font-size:1.25rem;
                  line-height:35px;
              }
              .use-button {
                  width:9rem;
                  height:2.875rem;
                  cursor:pointer;
                  background: #2372E9;
                  line-height:2.875rem;
                  text-align:center;
                  margin-top:6.18rem;
                  border-radius:30px;
              }
          }
      }
      .block-wrap {
          width:100%;
          position:relative;
          padding-top:4.625rem;
          .block-title {
              position:relative;
              position:relative;
              text-align:center;
          }
              .block-desc {
                  margin:4.625rem auto 3.75rem;
                  line-height:32px;
                  text-align:center;
              }
      }
      .content-wrap {
        max-width:var(--main-width);
        width:84%;
          margin:0 auto;
          padding-bottom:5.8rem;
          text-align:center;
          img {
              width:1134px;
          }
          .product-row {
              display:flex;
              justify-content:space-between;
              margin-top:4.93rem;
              flex-wrap:wrap;
              .product-column {
                  width:22%;
                  min-width:16rem;
              }
              .top-img {
                  background-color:#E6E6E6;
                  height:196px;
                  background-repeat:no-repeat;
                  background-position:center;
              }
              .fly-block {
                  background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img4.png");
                  background-size:cover;
              }
              .analysis-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img5.png");
                background-size:cover;
              }
              .defect-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img6.png");
                background-size:cover;
              }
              .auto-defect-block {
                background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product-solar/function_img7.png");
                background-size:cover;
              }
              .bottom-text {
                  background-color:#fff;
                  padding:1rem 0 1.8rem;
                  .product-title {
                      margin-bottom:10px;
                      font-size:1.375rem;
                      font-weight:bold;
                  }
                  .product-desc {
                      color:#666666;
                      font-size:14px;
                      line-height:25px;
                      text-align:center;
                  }
              }
          }
      }

      .block-content {
        max-width:var(--main-width);
        width:84%;
          margin:7.56rem auto 0;
          margin-top:7.56rem;
          .content-row {
              display:flex;
              margin-bottom:4rem;
              >div {
                  flex:1;
              }
              .img-wrap {
                height:26.56rem;
                overflow:hidden;
              }
              .block-text {
                  padding:3rem 5.5rem;
                  .title {
                      color:#2372E9;
                      margin-bottom:3.18rem;
                      font-size:1.75rem;
                      font-weight:bold;
                  }
                  .desc {
                      color:#333333;
                      line-height:30px;
                      font-size:1rem;
                  }
              }
          }
      }
  }
  @media only screen and (max-width: 1200px) and (min-width: 768px) {
    .product-row {
      .product-column {
        margin-bottom:30px;
      }
    }
    .block-content {
        .content-row {
            flex-wrap:wrap;
            .img-wrap {
                img {
                    width:100%;
                }
            }
        }
        .row-left,.row-right {
            width:100%;
            flex:auto !important;
        }
    }
  }
  @media only screen and (max-width: 768px) {
    .pvscan-container {
    .layout-banner {
        height:380px !important;
        margin-top:108px;

        .text-block {
            transform:translateY(0);
            top:65px;
           .title {
            font-size:24px ;
            margin-bottom:10px !important;
        }
        .desc {
              line-height:20px;
            }
        }
        .use-button {
            display:none;
        }
    }
    .content-wrap {
       .product-row {
        flex-wrap:wrap;
        margin-top:0px;
      .product-column {
        margin-bottom:30px;
        margin-right:0 !important;
        width:100% !important;
        .bottom-text {
            padding-bottom:18px !important;
        }
      }
    }
    }

        .block-wrap {
        padding:25px 15px 0;
        width:auto;
        .block-title {
            font-size:22px ;
        }
        .block-desc {
            width:auto;
            padding:0 15px;
            margin-top:15px;
            font-size:14px;
            margin-bottom:29px;
            line-height:20px;
        }
    }
    }

    .block-content {
        .content-row {
            flex-wrap:wrap;
            .img-wrap {
                img {
                    width:100%;
                }
            }
        }
        .row-left,.row-right {
            width:100%;
            flex:auto !important;
        }
    }


    .platform-bg {
        width:345px !important;
    }
    .content-wrap {
        width:auto !important;
        padding-bottom:2rem !important;
    }
    .block-content {
        width:auto !important;
    }
    .pc-platform {
        display:none;
    }
    .mobile-platform {
        display:block !important;
        margin-top:37px !important;
    }
  }
</style>
